import type {
  ICommonPaginationMapperProps,
  PaginationLayout,
} from './Pagination.types';

export const isNextEnabled = ({
  forceNextButtonEnabled,
  isDisabled,
  currentPage,
  totalPages,
}: Pick<
  ICommonPaginationMapperProps,
  'forceNextButtonEnabled' | 'isDisabled' | 'currentPage' | 'totalPages'
>) =>
  typeof forceNextButtonEnabled !== 'undefined'
    ? forceNextButtonEnabled
    : !(isDisabled || currentPage >= totalPages);

export const isPreviousEnabled = ({
  forcePreviousButtonEnabled,
  isDisabled,
  currentPage,
}: Pick<
  ICommonPaginationMapperProps,
  'forcePreviousButtonEnabled' | 'isDisabled' | 'currentPage'
>) =>
  typeof forcePreviousButtonEnabled !== 'undefined'
    ? forcePreviousButtonEnabled
    : !(isDisabled || currentPage <= 1);

export const getResponsivePaginationLayout = (
  buttonLabelDisplay: string,
  buttonIconDisplay: string,
): PaginationLayout => {
  if (buttonLabelDisplay === 'none') {
    return 'arrows';
  } else if (buttonIconDisplay === 'none') {
    return 'text';
  } else {
    // TODO: Support both icon and label in the future
    return 'text';
  }
};
